import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

function CreateProfile() {
    const navigate = useNavigate();
    const [user, setUser] = useState([]);
    const [profile, setProfile] = useState({
        nom: 'Entrer un nom',
        url: 'https://mir-s3-cdn-cf.behance.net/project_modules/disp/84c20033850498.56ba69ac290ea.png'
    });
    const [message, setMessage] = useState('');
    const [isEditingName, setIsEditingName] = useState(false);
    const [isImageOptionsVisible, setIsImageOptionsVisible] = useState(false);

    const imageOptions = [
        'https://mir-s3-cdn-cf.behance.net/project_modules/disp/84c20033850498.56ba69ac290ea.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bdc9a33850498.56ba69ac2ba5b.png',
        'https://mir-s3-cdn-cf.behance.net/project_modules/disp/bf6e4a33850498.56ba69ac3064f.png',
    ];

    useEffect(() => {
        fetch('/user/details-user')
            .then((response) => response.json())
            .then((data) => {
                setUser(data);
                console.log(user.userId);
            })
            .catch((error) => console.error('Erreur requête :', error));
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`/profile/create/${user.userId}/profils`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(profile)
            });
            if (response.status === 201) {
                setMessage('Création du profil réussie');
                setTimeout(() => {
                    navigate("/");
                }, 800);
                
            } else {
                setMessage('Erreur serveur');
            }
        } catch (error) {
            setMessage('Erreur lors de la création');
        }
    };

    const handleNameChange = (e) => {
        const newName = e.target.value;
        setProfile({ ...profile, nom: newName });
    };

    const handleImageClick = () => {
        setIsImageOptionsVisible(!isImageOptionsVisible);
    };

    const handleImageOptionClick = (imageUrl) => {
        setProfile({ ...profile, url: imageUrl });
        setIsImageOptionsVisible(false);
    };

    return (
        <section className="container_news create">
            <div className="container_connexion create-profile">
                <h1>Créer un profil</h1>
                <form method="POST" onSubmit={handleSubmit} className="create-form">
                    <div className="preview" >
                        <img src={profile.url} alt="preview_pic_profile" onClick={handleImageClick} />
                        {isEditingName ? (
                            <input
                                type="text"
                                value={profile.nom}
                                onChange={handleNameChange}
                                onBlur={() => setIsEditingName(false)}
                                autoFocus
                            />
                        ) : (
                            <h5 onClick={() => setIsEditingName(true)}>{profile.nom}</h5>
                        )}
                    </div>
                    {isImageOptionsVisible && (
                        <div className="image-options">
                            {imageOptions.map((imageUrl, index) => (
                                <img
                                    key={index}
                                    src={imageUrl}
                                    alt={`image_option_${index}`}
                                    onClick={() => handleImageOptionClick(imageUrl)}
                                />
                            ))}
                        </div>
                    )}
                    <button type="submit" className="btn-lecture">
                        Créer le profil
                    </button>
                </form>
                <p>{message}</p>
            </div>
        </section>
    );
}

export default CreateProfile;
